import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ContactLogo from '../components/shared/ContactLogo';
import PlansCompareCards from '../components/shared/PlansCompareCards';
import { FEATURE_COPY } from '../components/shared/LockedFeature';
import { usePlan } from '../contexts/PlanContext';

/* The one real destination for "upgrade to Pro" anywhere in the app —
   every openUpgrade(feature) call (LockedFeature, Sidebar, LeadsPanel,
   IntegrationsPanel, DeveloperPanel, AppearanceEditor, SettingsPanel, the
   402 plan_upgrade_required handler in App.js, ProfilesManager's profile
   limit) ends up here via UpgradeModal, instead of the old WhatsApp
   "contáctanos" dead end. Optional ?feature=xxx shows why the visitor
   landed here, reusing the same copy LockedFeature already shows inline. */
const PlansPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { plan } = usePlan();
  const feature = searchParams.get('feature');
  const featureCopy = feature ? FEATURE_COPY[feature] : null;

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f7' }}>
      <header style={{ background: '#fff', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
        <div style={{ maxWidth: 960, margin: '0 auto', padding: '18px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <ContactLogo className="h-7 w-auto" clickable />
          <button
            onClick={() => navigate('/dashboard')}
            style={{ fontSize: 13.5, fontWeight: 500, color: '#6e6e73', background: 'none', border: 'none', cursor: 'pointer' }}
          >
            Volver al panel
          </button>
        </div>
      </header>

      <div style={{ maxWidth: 960, margin: '0 auto', padding: '48px 24px 64px' }}>
        {featureCopy && (
          <div
            style={{
              background: '#fff',
              border: '1px solid rgba(0,0,0,0.08)',
              borderRadius: 14,
              padding: '16px 20px',
              marginBottom: 32,
              maxWidth: 640,
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
            }}
          >
            <p style={{ fontSize: 13, color: '#6e6e73', margin: 0 }}>
              Para usar <strong style={{ color: '#1d1d1f' }}>{featureCopy.title}</strong> necesitas actualizar tu plan.
            </p>
          </div>
        )}

        <PlansCompareCards currentPlanId={plan?.plan_id || 'free'} renewable={Boolean(plan?.expires_at)} />
      </div>
    </div>
  );
};

export default PlansPage;
